import axios from "axios"
import FormButton from "../../components/FormButton"
import { getToken } from "../../user/User"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const StatusDetailView = ({ id,
    name, setName,
    remindTimeInDays, setRemindTimeInDays,
}) => {
    const navigate = useNavigate()
    
    const handleBack = async e => {
        e.preventDefault()
        navigate("/status")
    }

    const onSave = async e => {
        e.preventDefault()

        axios.put(process.env.REACT_APP_API_URL + "/api/status/" + id, JSON.stringify({
            "remind_time_in_days": parseInt(remindTimeInDays),
        }), { headers: {
            "Authorization": "Bearer " + getToken()
        }}).then(_ => {
            toast.success("Saved status " + name + " (#" + id + ").")
        }).catch(error => {
            if (error.response) {
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Invalid request.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Unable to find status #" + id + ".")
                    return
                }
            }
            toast.error("Internal error")
        })
    }

    return (
        <>
            <button className="btn btn-primary back" onClick={handleBack}>Back to overview</button><br /><br />

            <form className="form-horizontal">
                <div className="card card-primary">
                    <div className="card-body">
                        <div className="col-12">
                            <div className="row">
                                <FormButton label="Name" id="name" disabled={true} required="required" value={name} setValue={setName} icon="fa-solid fa-bars-progress" />
                                <FormButton label="Remind time in days" id="remindTimeInDays" required="required" value={remindTimeInDays} setValue={setRemindTimeInDays} icon="fa-solid fa-timer" />
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <button className="btn btn-primary" onClick={onSave}>Save status</button>
                    </div>
                </div>
            </form>
        </>
    )
}
   
export default StatusDetailView